import { css, SerializedStyles } from '@core-ui/react-stitch';

const getRailContainerStyles = (
  isMobileStyle: boolean,
  isBRRedesignEnabled: boolean,
  isFixedHeader: boolean
): SerializedStyles => {
  let styles = `
    display: flex;
    padding: ${isMobileStyle ? '0 0 0.5rem 0' : '1rem 0 0 0'};
    width: ${isMobileStyle ? '100%' : 'initial'};
  `;

  if (isBRRedesignEnabled) {
    styles += `
      position: sticky;
      top: ${isFixedHeader ? '118px' : '65px'};
      z-index: 100;
    `;
  }

  return css(styles);
};

const getItemCountAndClearAllCombinedStyles = (isMobileStyle: boolean): SerializedStyles => css`
  border-top: ${isMobileStyle ? 'unset' : '1px solid #CCCCCC'};
  margin: ${isMobileStyle ? '1rem' : '.5rem auto'};
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 0;
`;


export {
  getRailContainerStyles,
  getItemCountAndClearAllCombinedStyles
};
